import { useParams } from '@/js/libs/router';

import type { BroadcastRouteParams } from '../types';

export const useRouteParams = () => useParams<BroadcastRouteParams>();
